import React, { useMemo } from 'react';
import { useField } from 'formik';
import {
  Geo,
  InputStyle,
  InputStyleWrapper,
  InputValidationMessage,
  LocationSelect,
} from '@getvim/atomic-ui';
import '../InputField.less';
import './AddressInputField.less';
import addressFormat, {
  formatGeoToAddress,
  formatToGeo,
} from '../../../../../utils/addressFormatter';

export const AddressInputField: React.FC = () => {
  const [, meta, helpers] = useField('address');

  const onChange = (geoInput: Geo | null) => {
    helpers.setTouched(true);
    const geoAsAddress = formatGeoToAddress(geoInput);
    helpers.setValue(geoAsAddress && { ...geoAsAddress, fullAddress: addressFormat(geoAsAddress) });
  };

  // Selection with coords AND zip -> pass `geo` (formatToGeo attaches the geocode) for one stable
  // "City, ST zip" with no blur resync; coords without zip would re-geocode, so fall through to
  // display only. Memoized so geo identity stays stable across Formik re-renders, else
  // LocationSelect re-fires its effect.
  const locationProps = useMemo(() => {
    if (meta.value?.coordinates && meta.value?.zipCode) return { geo: formatToGeo(meta.value) };
    return meta.value ? { defaultAddressInput: meta.value.fullAddress } : {};
  }, [meta.value]);

  return (
    <div className="referral-request-input-container">
      <InputStyleWrapper
        className="location-input-wrapper input-wrapper"
        inputStyle={InputStyle.pillMedium}
        hasError={meta.touched && !!meta.error}
        rightIcon={<></>}
      >
        <div className="input">
          <LocationSelect
            label="Location"
            placeholder=" "
            isGoogleApiLoaded
            showChevronIcon
            onChange={(changedGeo) => onChange(changedGeo)}
            {...locationProps}
          />
        </div>

        {meta.touched && meta.error && (
          <InputValidationMessage>Address is required</InputValidationMessage>
        )}
      </InputStyleWrapper>
    </div>
  );
};
